import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useEffect, useRef, useState } from 'react'
import { Arrow } from 'shared'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const useStyles = makeStyles((theme) => {
  return {
    slider: {
      '& .slick-slide > div': {
        padding: '0 12px',
      },

      '& .slick-slide': {
        transition: '150ms',
        opacity: '0.2',
        scale: '0.95',
        pointerEvents: 'none',
      },

      '& .slick-slide.slick-active': {
        pointerEvents: 'all',
        opacity: 1,
        scale: '1.05',
      },

      '& .slick-list': {
        height: '520px',
        margin: '0 -12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },

      '& .slick-dots': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bottom: '-30px',
      },

      '& .slick-dots li button:before': {
        fontSize: '10px',
      },
      [theme.breakpoints.down('sm')]: {
        '& .slick-slide > div': {
          padding: '0 6px',
        },
        '& .slick-list': {
          margin: '0 -6px',
        },
      },
    },
  }
})

const srcs = [
  'https://hue-admin-dev.s3.us-east-1.amazonaws.com/creators-profile-form-videos/angela-fekkai.mov',
  'https://hue-admin-dev.s3.us-east-1.amazonaws.com/creators-profile-form-videos/1707769540973-3-TracyAnn-Johnson.mov',
  'https://hue-admin-dev.s3.us-east-1.amazonaws.com/creators-profile-form-videos/maison-miru.mov',
]

const Video = ({
  activeIndex,
  ownIndex,
  src,
}: {
  activeIndex: number
  src: string
  ownIndex: number
}) => {
  const ref = useRef<HTMLVideoElement | null>(null)

  useEffect(() => {
    if (!ref.current) return

    if (activeIndex !== ownIndex) {
      ref.current.pause()
    }
  }, [activeIndex, ownIndex])

  return (
    <Grid width="100%" height="100%" position="relative">
      <video
        controls
        ref={ref}
        src={`${src}#t=0.1`}
        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
      ></video>
    </Grid>
  )
}

export const VideosSlider = () => {
  const classes = useStyles()
  const ref = useRef<Slider | null>(null)
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <Grid>
      <Slider
        infinite={false}
        ref={ref}
        initialSlide={1}
        dots
        swipe={false}
        slidesToShow={1}
        slidesToScroll={1}
        className={classes.slider}
        centerMode
        arrows={false}
        centerPadding="250px"
        beforeChange={(_, index) => setActiveIndex(index)}
        responsive={[
          {
            breakpoint: 600,
            settings: {
              swipe: true,
              centerPadding: '25px',
            },
          },
        ]}
        appendDots={(dots) => {
          return (
            <Grid>
              <Arrow
                onClick={() => ref.current?.slickPrev()}
                sx={{ transform: 'rotate(90deg)', cursor: 'pointer', mr: 4 }}
              />
              {dots}
              <Arrow
                onClick={() => ref.current?.slickNext()}
                sx={{ transform: 'rotate(-90deg)', cursor: 'pointer', ml: 4 }}
              />
            </Grid>
          )
        }}
      >
        {srcs.map((src, index) => {
          return (
            <Grid
              key={index}
              height="490px"
              className="slide-content"
              overflow="hidden"
              borderRadius="16px"
            >
              <Video activeIndex={activeIndex} ownIndex={index} src={src} />
            </Grid>
          )
        })}
      </Slider>
    </Grid>
  )
}
